export default "__VITE_ASSET__pKtyjGZ0__"